import { createSlice } from "@reduxjs/toolkit"
import { ApiRequest } from "src/models/api.request";
import VwDrhakedissorguDTO from "src/models/DrHAkedis/VwDrhakedissorguDTO";
import VwHbsHakedis1DTO from "src/models/DrHAkedis/VwHbsHakedis1DTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads"
import { helper } from "src/utils/helper";


class ISearchType {
    basTarih : string = helper.datetimeToday();
    bitTarih : string = helper.datetimeToday();
    kurumId : string = "";
    doktorId : string = "";
}

class ISearchType2 {
    basTarih : string = helper.datetimeToday();
    bitTarih : string = helper.datetimeToday();
    kurumId : string = "";
    doktorId : string = "";
}

interface IDrHakedisType {
    searchModel : ISearchType,
    searchModel2: ISearchType2,
    submitForm : boolean,
    submitForm2 : boolean,
    filterModel: ApiRequest<VwDrhakedissorguDTO>,
    filterModel1: ApiRequest<VwHbsHakedis1DTO>
}

const DrHakedisSlice = createSlice<IDrHakedisType,MapReducerPayloads<IDrHakedisType, {
    setState : IDrHakedisType,
    setSubmitForm : boolean,
    setSubmitForm2 : boolean,
    setfilterModel1 : ApiRequest<VwHbsHakedis1DTO>
}>>({
    name : "DrHakedis",
    initialState : {
        searchModel : new  ISearchType(),
        searchModel2: new ISearchType2(),
        submitForm : false,
        submitForm2 : false,
        filterModel : new ApiRequest<VwDrhakedissorguDTO>(),
        filterModel1: new ApiRequest<VwHbsHakedis1DTO>()
    },
    reducers : {
        setState : (state,action) => action.payload,
        setSubmitForm : (state, action) => {
            state.submitForm = action.payload
        },
        setSubmitForm2 : (state, action) => {
            state.submitForm2 = action.payload
        },
        setfilterModel1 :(state,action) => {
            state.filterModel1 = action.payload
        }
    }
})

export default DrHakedisSlice